/*
  useDebounce.js
*/

// Npm.
import { useState, useEffect } from 'react';

/**
 * Returns a debounced value.
 */
export default function useDebounce(value, delay = 0) {

  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (delay > 0) {

      const timeout = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(timeout);
      };

    }
  }, [value, delay]);

  return delay > 0 ? debouncedValue : value;

}